// Only GATSBY_-prefixed env vars reach browser code, so process.env.DOMAIN is empty
// client-side; default to the production domain.
export const domain = process.env.DOMAIN || 'https://offspringdigital.com'
